/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
import reportsStatus from 'state/reducers/reportsState/reports_status';
import selectedReportStatus from 'state/reducers/reportsState/selected_report_status'



/* ========== ~~~~~~~~~~ REPORTS STATE : ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js
const reportsStateRootReducer = combineReducers({
    reportsStatus,
    selectedReportStatus
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default reportsStateRootReducer;
